module.exports = __webpack_public_path__ + "img/lt.ce94149e.svg";